import React from "react";
import Icon from "@/components/ui/Icon";
import styles from "./styles.module.scss";

export const PASSWORD_RULES: { label: string; test: (pw: string) => boolean }[] = [
  { label: "Pelo menos 8 caracteres", test: (pw) => pw.length >= 8 },
  { label: "Uma letra minúscula", test: (pw) => /[a-z]/.test(pw) },
  { label: "Uma letra maiúscula", test: (pw) => /[A-Z]/.test(pw) },
  { label: "Um número", test: (pw) => /\d/.test(pw) },
  { label: "Um caractere especial (!@#$%^&*)", test: (pw) => /[!@#$%^&*(),.?":{}|<>]/.test(pw) },
];

export const isStrongPassword = (pw: string) => PASSWORD_RULES.every((rule) => rule.test(pw));

// Lista de requisitos da senha que marca cada item conforme o usuário digita.
const PasswordRules: React.FC<{ password: string }> = ({ password }) => (
  <ul className={styles.rules} aria-label="Requisitos da senha">
    {PASSWORD_RULES.map((rule) => {
      const ok = rule.test(password);
      return (
        <li key={rule.label} className={ok ? styles.ok : undefined}>
          <span>{ok && <Icon name="check" size={10} strokeWidth={3.4} />}</span>
          {rule.label}
        </li>
      );
    })}
  </ul>
);

export default PasswordRules;
